module.exports = __webpack_public_path__ + "static/media/alarm-exclamation.16fec459.svg";